import { render, staticRenderFns } from "./AmountInput.vue?vue&type=template&id=87556d5a&"
import script from "./AmountInput.vue?vue&type=script&lang=js&"
export * from "./AmountInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports